export default __webpack_public_path__ + "static/media/ea-grey.a95ee77b.svg";